import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 py-12">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="text-center md:text-left">
          <h2 className="text-2xl font-heading font-bold korov-gradient-text mb-2 transition-all duration-300 cursor-default">KOROV</h2>
          <p className="text-muted-foreground text-sm font-body">© {new Date().getFullYear()} Dharmar Records. All rights reserved.</p>
        </div>
        
        <div className="flex gap-8 text-sm text-muted-foreground font-body">
          <a href="#" className="hover:text-primary hover:text-glow transition-all duration-300">Privacy Policy</a>
          <a href="#" className="hover:text-primary hover:text-glow transition-all duration-300">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
